import { Button, Fieldset, Group, LoadingOverlay, Stack } from "@mantine/core";
import { useRef, useState } from "react";
import TextEditor from "../../../../../../../components/ExternalEditors/TextEditor";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import {
  createNote,
  uploadNoteAttachments,
} from "../../../../../../../api/PRMAPI";
import { useLeadsSheetStore } from "../../../../../../../stores/LeadsStore";
import { notifications } from "@mantine/notifications";
import BackButton from "../../../../../../../components/View/BackButton";
import { IconDeviceFloppy } from "@tabler/icons-react";
import { useProfileStore } from "../../../../../../../stores/UserStore";
import NoteAttachments from "./NoteAttachments";
import AddNoteAttachments from "./AddNoteAttachments";

const AddNoteContent = ({ onClose }) => {
  const editorRef = useRef();
  const lang = useLanguage((s) => s.language);
  const profile = useProfileStore((s) => s.profile);
  const current = useLeadsSheetStore((s) => s.current);
  const setCurrent = useLeadsSheetStore((s) => s.setCurrent);
  const setActiveTab = useLeadsSheetStore((s) => s.setActiveTab);
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);

  const handleClose = () => {
    setCurrent({
      ...current,
      history: current.history.filter((x) => !x?.isCreate),
    });
    onClose?.();
  };

  const handleSave = () => {
    setLoading(true);
    const html = editorRef.current.getContent();

    createNote({ prospect_id: current?.id, note: html })
      .then(async (response) => {
        let attachments = null;

        if (files.length > 0) {
          try {
            let formData = new FormData();

            files?.forEach((file) => {
              formData.append("attachments[]", file);
            });

            attachments = await uploadNoteAttachments({
              note_id: response.data.note_id,
              prospect_id: current.id,
              formData,
            });
          } catch (error) {
            console.error("Attachment upload failed:", error);
          }
        }

        let newNote = {
          date: new Date().toISOString(),
          id: response.data.note_id,
          created_by: {
            id: profile.id,
            first_name: profile.first_name,
            last_name: profile.last_name,
          },
          date_updated: null,
          note: html,
          history_type: "note",
          attachments: attachments?.data?.attachment_ids?.length
            ? files?.map((x) => ({
                ...x,
                filename: x.name,
                file_size: x.size,
                file: x,
              }))
            : [],
        };

        notifications.show({
          message: lang.prm.details.notes.created,
          color: "tertiary.8",
        });

        setCurrent({
          ...current,
          history: [
            newNote,
            ...(current?.history?.filter((x) => !x?.isCreate) || []),
          ],
        });

        onClose?.();
        onClose && setActiveTab("notes");
      })
      .finally(() => setLoading(false));
  };

  return (
    <Stack w={"100%"} p={4} gap={8} flex={1}>
      <LoadingOverlay visible={loading} />
      <TextEditor
        editorRef={editorRef}
        id={"note-creator"}
        placeholder={lang.prm.details.notes.placeholder}
        isText
        autoSize
        noTop
        toolbar="bold italic underline numlist bullist link |"
        onInit={(editor) =>
          editor.setContent(
            `<br /><br /> - ${profile.first_name} ${profile?.last_name}`
          )
        }
        autoFocus
        data-autofocus
      />

      <NoteAttachments files={files} setFiles={setFiles} />
      <Group justify="end">
        <AddNoteAttachments files={files} setFiles={setFiles} />
        <BackButton onClick={handleClose} ml="auto" />
        <Button
          loading={loading}
          onClick={handleSave}
          leftSection={<IconDeviceFloppy size={18} />}
        >
          {lang.prm.details.notes.create}
        </Button>
      </Group>
    </Stack>
  );
};

export default AddNoteContent;
